// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/Logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/premiumfeature/topnav_premiumstar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-sidebar {
  position: absolute;
  z-index: 33;
  background-color: #FFF;
  border-right: 1px solid #E8E9F0;
  width: 54px;
  height: 100vh;
}

.header-toolbar {
  background-color: #002E33;
  height: 40px;
}
.header-toolbar #logo {
  height: 40px;
  width: 34px;
  left: 24px;
  position: absolute;
  top: 0;
  z-index: 26;
  background-size: contain;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat scroll center;
}
.header-toolbar .Menu {
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 72px;
  height: 40px;
  right: 0;
  z-index: 25;
  background-color: #FFF;
  -webkit-box-shadow: 1px 0 2px #E8E9F0;
          box-shadow: 1px 0 2px #E8E9F0;
  color: #002E33;
  line-height: 22px;
  font-size: 11px;
  border-bottom: 1px solid #D9DCE5;
}
.header-toolbar .Menu__link--premium {
  position: relative;
  padding-right: 30px !important;
}
.header-toolbar .Menu__link--premium::after {
  content: " ";
  display: block;
  position: absolute;
  top: 8px;
  right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  width: 16px;
  height: 16px;
  z-index: 1;
}
.header-toolbar .Menu a {
  -webkit-text-decoration: none;
  text-decoration: none;
}
.header-toolbar .Menu a.link {
  display: inline-block;
  padding: 0 8px;
  height: 40px;
  line-height: 36px;
  font-size: 16px;
  color: #002E33;
  cursor: pointer;
}
.header-toolbar .Menu a.link.right {
  float: right;
}
.header-toolbar .Menu a.link.active {
  background: #FFF;
  font-weight: bold;
  -webkit-box-shadow: 0px -2px 0px #01FF94 inset;
          box-shadow: 0px -2px 0px #01FF94 inset;
}
.header-toolbar .Menu a.link:hover {
  background: #FFF;
  font-weight: bold;
  -webkit-box-shadow: 0px -2px 0px #01FF94 inset;
          box-shadow: 0px -2px 0px #01FF94 inset;
}
.header-toolbar .Menu a.link::before {
  display: block;
  content: attr(title);
  font-weight: bold;
  height: 1px;
  color: transparent;
  overflow: hidden;
  visibility: hidden;
}
.header-toolbar .Menu div.left,
.header-toolbar .Menu div.right {
  display: block;
  position: fixed;
}
.header-toolbar .Menu div.right {
  float: right;
  right: 0;
  left: auto;
  left: initial;
}
.header-toolbar .Menu div.left {
  margin-left: 0;
  right: auto;
  right: initial;
}
.header-toolbar .Menu .burger {
  display: none;
  float: left;
}
.header-toolbar .Menu .burger > a {
  width: 20px;
  height: 40px;
}
.header-toolbar .Menu .burger .burgerMenu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  position: absolute;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background-color: #FFF;
  left: 30px;
  margin-top: 10px;
  top: 100%;
  right: 0;
  padding: 8px;
  border: 1px solid #E8E9F0;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  border-radius: 12px;
}
.header-toolbar .Menu .burger .burgerMenu:after, .header-toolbar .Menu .burger .burgerMenu:before {
  right: 10px !important;
  left: 84px;
  top: -8px;
}
.header-toolbar .Menu .burger .burgerMenu:after {
  border-color: #FFF transparent;
}
.header-toolbar .Menu .burger .burgerMenu.hidden {
  display: none;
}
.header-toolbar .Menu .burger .burgerMenu a.link {
  width: auto;
  width: initial;
  font-size: 16px;
  height: 16px;
  line-height: 16px;
  padding: 12px 24px;
  border: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  border-radius: 6px;
}
.header-toolbar .Menu .burger .burgerMenu a.link:hover {
  color: #01FF94;
  background-color: #002E33;
  border-radius: 6px;
  -webkit-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
}
.header-toolbar.agerasNextMigration #logo {
  left: 78px;
}
.header-toolbar.agerasNextMigration .Menu {
  left: 54px;
}

@media screen and (max-width: 1024px) {
  .Menu .burger {
    display: block !important;
  }
  .Menu div.left {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/Menu.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,WAAA;EACA,sBCEM;EDDN,+BAAA;EACA,WAAA;EACA,aAAA;AAFF;;AAKA;EACE,yBCXa;EDYb,YAAA;AAFF;AAIE;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,wBAAA;EACA,2EAAA;AAFJ;AAKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,sBC3BI;ED4BJ,qCAAA;UAAA,6BAAA;EACA,cCnCW;EDoCX,iBAAA;EACA,eAAA;EACA,gCAAA;AAHJ;AAKI;EACE,kBAAA;EACA,8BAAA;AAHN;AAKM;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2EAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAHR;AAOI;EACE,6BAAA;EAAA,qBAAA;AALN;AAQI;EACE,qBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,cCnES;EDoET,eAAA;AANN;AAQM;EACE,YAAA;AANR;AASM;EACE,gBCrEA;EDsEA,iBAAA;EACA,8CAAA;UAAA,sCAAA;AAPR;AAUM;EACE,gBC3EA;ED4EA,iBAAA;EACA,8CAAA;UAAA,sCAAA;AARR;AAWM;EACE,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AATR;AAaI;;EAEE,cAAA;EACA,eAAA;AAXN;AAaI;EACE,YAAA;EACA,QAAA;EACA,UAAA;EAAA,aAAA;AAXN;AAaI;EACE,cAAA;EACA,WAAA;EAAA,cAAA;AAXN;AAcI;EACE,aAAA;EACA,WAAA;AAZN;AAcM;EACE,WAAA;EACA,YAAA;AAZR;AAeM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,kBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,sBCxHA;EDyHA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,wDAAA;UAAA,gDAAA;EACA,mBAAA;AAbR;AAeQ;EACE,sBAAA;EACA,UAAA;EACA,SAAA;AAbV;AAeQ;EACE,8BAAA;AAbV;AAgBQ;EACE,aAAA;AAdV;AAiBQ;EACE,WAAA;EAAA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;UAAA,gBAAA;EACA,kBAAA;AAfV;AAiBU;EACE,cCjKI;EDkKJ,yBCjKG;EDkKH,kBAAA;EACA,yCAAA;EAAA,iCAAA;AAfZ;AAwBI;EACE,UAAA;AAtBN;AAwBI;EACE,UAAA;AAtBN;;AA2BA;EAEI;IACE,yBAAA;EAzBJ;EA2BE;IACE,wBAAA;EAzBJ;AACF","sourcesContent":["@import \"../Global/Layout.scss\";\n@import \"../Global/Colors.scss\";\n\n.header-sidebar {\n  position: absolute;\n  z-index: 33;\n  background-color: $White;\n  border-right: 1px solid $Gray30;\n  width: 54px;\n  height: 100vh;\n}\n\n.header-toolbar {\n  background-color: $DeepSeaGreen;\n  height: 40px;\n\n  #logo {\n    height: 40px;\n    width: 34px;\n    left: 24px;\n    position: absolute;\n    top: 0;\n    z-index: 26;\n    background-size: contain;\n    background: url('~images/Logo.svg') no-repeat scroll center;\n  }\n\n  .Menu {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding-left: 72px;\n    height: 40px;\n    right: 0;\n    z-index: 25;\n    background-color: $White;\n    box-shadow: 1px 0 2px $Gray30;\n    color: $DeepSeaGreen;\n    line-height: 22px;\n    font-size: 11px;\n    border-bottom: 1px solid $Gray40;\n\n    &__link--premium {\n      position: relative;\n      padding-right: 30px !important;\n\n      &::after {\n        content: ' ';\n        display: block;\n        position: absolute;\n        top: 8px;\n        right: 10px;\n        background: url('~images/premiumfeature/topnav_premiumstar.svg') no-repeat center center;\n        width: 16px;\n        height: 16px;\n        z-index: 1;\n      }\n    }\n\n    a {\n      text-decoration: none;\n    }\n\n    a.link {\n      display: inline-block;\n      padding: 0 8px;\n      height: 40px;\n      line-height: 36px;\n      font-size: 16px;\n      color: $DeepSeaGreen;\n      cursor: pointer;\n\n      &.right {\n        float: right;\n      }\n\n      &.active {\n        background: $White;\n        font-weight: bold;\n        box-shadow: 0px -2px 0px $ElectricGreen inset;\n      }\n\n      &:hover {\n        background: $White;\n        font-weight: bold;\n        box-shadow: 0px -2px 0px $ElectricGreen inset;\n      }\n\n      &::before {\n        display: block;\n        content: attr(title);\n        font-weight: bold;\n        height: 1px;\n        color: transparent;\n        overflow: hidden;\n        visibility: hidden;\n      }\n    }\n\n    div.left,\n    div.right {\n      display: block;\n      position: fixed;\n    }\n    div.right {\n      float: right;\n      right: 0;\n      left: unset;\n    }\n    div.left {\n      margin-left: 0;\n      right: unset;\n    }\n\n    .burger {\n      display: none;\n      float: left;\n\n      > a {\n        width: 20px;\n        height: 40px;\n      }\n\n      .burgerMenu {\n        display:flex;\n        flex-direction: column;\n        position: absolute;\n        width: fit-content;\n        background-color: $White;\n        left: 30px;\n        margin-top: 10px;\n        top: 100%;\n        right: 0;\n        padding: 8px;\n        border: 1px solid $Gray30;\n        box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n        border-radius: 12px;\n\n        &:after, &:before {\n          right: 10px !important;\n          left: 84px;\n          top: -8px;\n        }\n        &:after {\n          border-color: $White transparent;\n        }\n\n        &.hidden {\n          display: none;\n        }\n\n        a.link {\n          width: unset;\n          font-size: 16px;\n          height: 16px;\n          line-height: 16px;\n          padding: 12px 24px;\n          border: none;\n          box-shadow: none;\n          border-radius: 6px;\n\n          &:hover {\n            color: $ElectricGreen;\n            background-color: $DeepSeaGreen;\n            border-radius: 6px;\n            transition: all 0.25s ease-in-out;\n\n          }\n        }\n      }\n    }\n  }\n\n  &.agerasNextMigration {\n    #logo {\n      left: 78px;\n    }\n    .Menu {\n      left: 54px;\n    }\n  }\n}\n\n@media screen and (max-width: $pageWidthOneColumn) {\n  .Menu {\n    .burger {\n      display: block !important;\n    }\n    div.left {\n      display: none !important;\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
